import { useCallback, useMemo, useState } from 'react';
import PermissionService from '../services/Permission.service';
import UserService from '../services/UserService';

export default function usePermission() {
    const [permission, setPermission] = useState([]);

    const getUserPermission = useCallback(async () => {
        try {
            const { data } = await PermissionService.getUserPermission();
            if (data?.resultData) {
                setPermission(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const isUser = useMemo(
        () =>
            UserService.role() && UserService.role()?.toLowerCase() === 'user',
        []
    );

    const isAuditor = useMemo(
        () =>
            UserService.role() &&
            UserService.role()?.toLowerCase() === 'auditor',
        []
    );

    return {
        isUser,
        isAuditor,
        permission,
        getUserPermission,
    };
}
